import { createContext, useContext, ReactNode, useRef } from "react";
import { SubmittedFormModel } from "app/services/api/types/forms/models/SubmittedFormModel";
import {
  AssessmentReportFillModal,
  AssessmentReportFillModalRef,
} from "../modals/AssessmentReportFillModal";

interface AssessmentEditContextType {
  openEditModal: (entry: SubmittedFormModel) => void;
}

const AssessmentEditContext = createContext<
  AssessmentEditContextType | undefined
>(undefined);

interface AssessmentEntryEditProviderProps {
  children: ReactNode;
}

export function AssessmentEntryEditProvider({
  children,
}: AssessmentEntryEditProviderProps) {
  const modalRef = useRef<AssessmentReportFillModalRef>(null);

  const openEditModal = (entry: SubmittedFormModel) => {
    modalRef.current?.open({ entry });
  };

  return (
    <AssessmentEditContext.Provider
      value={{
        openEditModal,
      }}
    >
      {children}
      <AssessmentReportFillModal ref={modalRef} />
    </AssessmentEditContext.Provider>
  );
}

export function useAssessmentEntryEdit() {
  const context = useContext(AssessmentEditContext);
  if (context === undefined) {
    throw new Error(
      "useAssessmentEntryEdit must be used within an AssessmentEntryEditProvider",
    );
  }
  return context;
}
